import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { Modal } from "@circle-react-uikit/ModalV2";
import { PlansModalBody } from "./PlansModalBody";

const PlansModalComponent = () => {
  const modal = useModal();

  const handleOnClose = async () => {
    await modal.hide();
    modal.remove();
  };

  return (
    <Modal isOpen={modal.visible} onClose={handleOnClose}>
      <Modal.Overlay />
      <Modal.Content size="full">
        <Modal.Header className="!justify-end">
          <Modal.HeaderActions>
            <Modal.CloseButton onClick={handleOnClose} />
          </Modal.HeaderActions>
        </Modal.Header>
        <PlansModalBody />
      </Modal.Content>
    </Modal>
  );
};

const PlansModal = ModalManager.create(() => <PlansModalComponent />);

export const usePlansModal = () => useModal(PlansModal);
